<div class="auth-container"><auth-form></auth-form></div>